"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M8 9.86v4.28L11.03 12z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M14.5 12 6 6v12zM8 9.86 11.03 12 8 14.14zM16 6h2v12h-2z"
}, "1")], 'SkipNextTwoTone');